module.exports = __webpack_public_path__ + "img/rueckseite_neu_generic.53ebdb77.svg";